import React from 'react'
import * as yup from 'yup';
import ModalContainerSmall from '../ModalContainerSmall'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch } from 'react-redux';
import { SET_MAIN_LOADER } from '../../../redux/loaderSlice';
import { SocketState } from '../../../context/SocketProvider';


const schema = yup.object().shape({
  old_password: yup
    .string()
    .required('Please enter your password.'),
  password: yup
    .string()
    .required('Please enter your password.')
    .min(4, 'Password is too short - must be at least 4 chars.'),
  conformPassword: yup.string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
});


const defaultValues = {
  old_password: '',
  password: '',
  conformPassword: '',
};


function ResetPasswordModal() {
const dispatch = useDispatch()
const {socket} = SocketState()

  const { control, formState, handleSubmit } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });

  const { errors } = formState;


  let onSubmit = ({old_password,password}) => {

    let data = {
      "en": "RESET_PASSWORD",
      "data": {
        old_password,
        "new_password": password,
      }
    }
    // console.log("data",data);
    dispatch(SET_MAIN_LOADER(true))
    socket.emit('req', data)


  }

  return (
    <ModalContainerSmall title={'Reset Password'} navigation={'/2d'} >
      <form
        name="resetForm"
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className='w-full'>

          {/* old password */}
          <div className='flex px-10 pt-10 '>
            <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>Old Password</p></div>
            <div className='w-1/2'>
              <Controller
                name="old_password"
                control={control}
                render={({ field }) => (
                  <input
                    className="shadow appearance-none border border-gray-400 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    type="password"
                    placeholder="old Password"
                    {...field}
                  />
                )} />
              <ErrorMessage errors={errors} name="old_password" render={({ message }) => <p className="text-red-500">{message}</p>} />
            </div>
          </div>

          {/* new password */}
          <div className='flex px-10 pt-4'>
            <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>New Password</p></div>
            <div className='w-1/2'>
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <input
                    className="shadow appearance-none border border-gray-400 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    type="password"
                    placeholder="password"
                    {...field}
                  />
                )} />
              <ErrorMessage errors={errors} name="password" render={({ message }) => <p className="text-red-500">{message}</p>} />
            </div>
          </div>


          {/* conform password */}
          <div className='flex px-10  pt-4'>
            <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>Conform Password</p></div>
            <div className='w-1/2'>
              <Controller
                name="conformPassword"
                control={control}
                render={({ field }) => (
                  <input
                    className="shadow appearance-none border border-gray-400 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    type="password"
                    placeholder="conform Password"
                    {...field}
                  />
                )} />
              <ErrorMessage errors={errors} name="conformPassword" render={({ message }) => <p className="text-red-500">{message}</p>} />
            </div>
          </div>
{/*  */}



          <div className='flex justify-center mt-8'>
            <button
              className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-1/4"
              type="submit"
            // onClick={cancelTicket}

            >
              Submit
            </button>
          </div>


        </div>
      </form>
    </ModalContainerSmall>
  )
}

export default ResetPasswordModal